/**
 * Personal email providers (SC-438). A company never owns one of these: matching and claiming
 * both ignore them, or the first gmail.com company would capture every gmail user.
 *
 * Mirrored in `cloud/utils/emailDomainRules.js`, because cloud code can't import types/.
 * `server/__tests__/emailDomains.parity.test.ts` keeps the two in sync.
 */
export const COMMON_EMAIL_DOMAINS: readonly string[] = [
  'gmail.com', 'googlemail.com',
  'outlook.com', 'hotmail.com', 'hotmail.co.uk', 'live.com', 'msn.com',
  'yahoo.com', 'yahoo.co.uk', 'ymail.com', 'rocketmail.com',
  'icloud.com', 'me.com', 'mac.com',
  'aol.com',
  'proton.me', 'protonmail.com', 'pm.me',
  'gmx.com', 'gmx.de', 'gmx.net', 'web.de', 't-online.de',
  'mail.com', 'zoho.com', 'zohomail.com', 'fastmail.com', 'hey.com',
  'tutanota.com', 'tuta.io',
  'yandex.com', 'yandex.ru', 'mail.ru',
  'qq.com', '163.com', '126.com',
  'naver.com', 'daum.net',
  'rediffmail.com',
  'comcast.net', 'verizon.net', 'att.net', 'btinternet.com',
  'orange.fr', 'free.fr', 'laposte.net', 'libero.it',
]

export function isCommonEmailDomain(domain: string): boolean {
  return COMMON_EMAIL_DOMAINS.includes(domain.trim().toLowerCase())
}

/** The domain of an email address, lower-cased, or '' when there is none. */
export function emailDomainOf(email: string | null | undefined): string {
  const value = String(email || '')
  const at = value.lastIndexOf('@')
  return at < 0 ? '' : value.slice(at + 1).trim().toLowerCase()
}

/**
 * A domain as people type it, reduced to the bare name: `https://www.Acme.io/about` and
 * `@acme.io` both become `acme.io`. Whether it is a valid, claimable domain is the cloud's call.
 */
export function cleanDomainInput(value: string): string {
  return String(value || '')
    .trim()
    .toLowerCase()
    .replace(/^[a-z]+:\/\//, '')
    .replace(/^@/, '')
    .replace(/^www\./, '')
    .replace(/[/?#].*$/, '')
    .replace(/\.$/, '')
}
